import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "ss-alinhar-centro" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Eu confirmo que revisei as contagens e todas informações do balanço, desejo finaliza-lo agora.", -1)
const _hoisted_5 = {
  key: 0,
  class: "ss-texto-centralizado"
}
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_icone = _resolveComponent("icone")!
  const _component_barra_progresso = _resolveComponent("barra-progresso")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_alert, {
      message: "Dica importante",
      description: "A conclusão do balanço pode demorar um pouco, sendo assim dê preferência para executar este processo fora do horário comercial ou tenha certeza que nenhuma movimentação será realizada neste período.",
      type: "info",
      "show-icon": ""
    }),
    _hoisted_1,
    _createVNode(_component_a_checkbox, {
      class: "ss-alinhar-centro ss-check-card",
      checked: _ctx.state.zerarProdutosNaoContados,
      "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.zerarProdutosNaoContados) = $event))
    }, {
      default: _withCtx(() => [
        _createTextVNode("Zerar as quantidades em estoque de todos os produtos que não foram contados neste balanço.")
      ]),
      _: 1
    }, 8, ["checked"]),
    _hoisted_2,
    _withDirectives(_createElementVNode("button", {
      type: "button",
      class: "ant-btn ant-btn-primary ant-btn-lg ss-tamanho-altura-completo",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.finalizarBalanco()))
    }, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_icone, {
          style: {"margin-right":"10px","font-size":"16px","vertical-align":"middle"},
          nome: "correto"
        }),
        _hoisted_4
      ])
    ], 512), [
      [_vShow, (!_ctx.state.finalizacaoEmAndamento)]
    ]),
    ((_ctx.state.finalizacaoEmAndamento))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _ctx.state.finalizacaoEmAndamento?'/static/img/ilustracoes/estoquista.gif':'',
            width: "300",
            alt: "Aguarde por favor"
          }, null, 8, _hoisted_6),
          _createVNode(_component_barra_progresso, {
            visivel: true,
            frase: "Aguarde por favor... Estamos finalizando o seu balanço e atualizando as movimentações de estoque."
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}